module.exports = __webpack_public_path__ + "img/thefirst.a94a8ab2.jpg";